// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
    nav: 'site-nav',
    navHome: 'nav-home-link',
    navFeaturesLink: 'nav-features-link',
    navHowLink: 'nav-how-it-works-link',
    navGetEngine: 'nav-get-engine-button',
    hero: 'hero-section',
    heroHeadline: 'hero-headline',
    heroCta: 'hero-get-engine-button',
    heroSecondaryCta: 'hero-how-it-works-button',
    heroVisual: 'hero-visual',
    heroStatusPill: 'hero-status-pill',
    marquee: 'editorial-marquee',
    features: 'features-section',
    featuresGrid: 'features-bento-grid',
    voiceTestLink: 'features-voice-test-link',
    voiceTest: 'voice-test-section',
    voiceTestStart: 'voice-test-start-button',
    voiceTestStop: 'voice-test-stop-button',
    voiceTestMeter: 'voice-test-meter',
    voiceTestStatusLabel: 'voice-test-status-label',
    voiceTestLevel: 'voice-test-level-readout',
    howItWorks: 'how-it-works-section',
    purchase: 'purchase-section',
    buyButton: 'purchase-get-engine-button',
    shopifyCheckoutSlot: 'shopify-checkout-placeholder',
    shopifyDeliverySlot: 'shopify-delivery-placeholder',
    faq: 'faq-section',
    footer: 'site-footer',
};
